<template>
  <div>
    <div class="container">
      <!-- 面包屑 -->
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('basicInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareRequirementsList')">联储联备</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareRequirementsList')">备件需求</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">详情</div>
      </div>
      <div class="sjz">
        <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
             v-for="(item, index) in steps"
             :key="index">
          <div class="sjz-item">
            <div :class="'sjz-icon '+ ((index>activeIndex)?'sjz-undone':(index===activeIndex)?'sjz-do':'')">
              <i class="el-icon-check"
                 style="width:40px;height:40px;"
                 v-if="index<activeIndex"></i>
              <span class="sjc-num sjc-do"
                    v-else-if="index===activeIndex">{{index+1}}</span>
              <span class="sjc-num"
                    v-else-if="index>activeIndex">{{index+1}}</span>
            </div>
            <div class="sjz-word">{{item.name}}</div>
            <div class="sjz-time">{{item.time}}</div>
          </div>
          <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
               v-if="index!==(steps.length-1)"></div>
        </div>
      </div>
      <div class="body-info">
        <!-- 客户评价填写 -->
        <div class="box-shadow"
             v-if="detailInfo && detailInfo.status === 5">
          <div class="right-content"
               style="width:1050px">
            <div class="commnet-top">
              <div class="comment-left">
                <img :src="BASE_URL + 'img/4_03.png'" />
                <p class="com-one">{{$t('evaluate.title')}}</p>
                <p class="com-two">请为本次服务做出评价</p>
              </div>
              <div class="comment-right">
                <div style="display:flex;">
                  <span class="row-item-label comment-row">{{$t('evaluate.speed')}}：</span>
                  <label class="row-item-conent">
                    <el-rate class="rate-choose"
                             :allow-half='true'
                             v-model="customerEvaluate.serviceResponse"></el-rate>
                  </label>
                </div>
                <div style="display:flex;">
                  <span class="row-item-label comment-row">{{$t('evaluate.quality')}}：</span>
                  <label class="row-item-conent">
                    <el-rate class="rate-choose"
                             :allow-half='true'
                             v-model="customerEvaluate.serviceQuality"></el-rate>
                  </label>
                </div>
                <div style="display:flex;">
                  <span class="row-item-label comment-row">{{$t('evaluate.easier')}}：</span>
                  <label class="row-item-conent">
                    <el-rate class="rate-choose"
                             :allow-half='true'
                             v-model="customerEvaluate.serviceFacilitate"></el-rate>
                  </label>
                </div>
              </div>
            </div>
            <div class="comment-bottom">
              <div class="bottom-left">{{$t('evaluate.feedback')}}：</div>
              <div class="bottom-right">
                <label class="row-item-conent"
                       style="max-width:880px; width:880px;">
                  <el-input type="textarea"
                            :maxlength="200"
                            :autosize="{ minRows: 4}"
                            placeholder="请输入评价内容(不超过200字...)"
                            v-model="customerEvaluate.feedbackContent"></el-input>
                </label>
              </div>
            </div>
          </div>
          <div class="submit-btn">
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 @click="handleSubmit()"
                 style="background-color:#1D65A8;color:#fff;">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>{{$t('order.submit')}}
            </div>
          </div>
        </div>
        <!-- 客户评价填写结束 -->
        <!-- 客户评价展示 -->
        <div class="box-shadow"
             v-if="detailInfo && detailInfo.status === 6 && detailInfo.signVo">
          <div class="right-content"
               style="width:1050px">
            <div class="commnet-top">
              <div class="comment-left">
                <img :src="BASE_URL + 'img/4_03.png'" />
                <p class="com-one com-new">{{$t('evaluate.title')}}</p>
                <!-- <p class="com-two">请为本次服务做出评价</p> -->
              </div>
              <div class="comment-right">
                <div style="display:flex;">
                  <span class="row-item-label comment-row">{{$t('evaluate.speed')}}：</span>
                  <label class="row-item-conent">
                    <el-rate class="rate-choose"
                             :disabled="true"
                             v-model="detailInfo.signVo.serviceResponse"></el-rate>
                  </label>
                </div>
                <div style="display:flex;">
                  <span class="row-item-label comment-row">{{$t('evaluate.quality')}}：</span>
                  <label class="row-item-conent">
                    <el-rate class="rate-choose"
                             :disabled="true"
                             v-model="detailInfo.signVo.serviceQuality"></el-rate>
                  </label>
                </div>
                <div style="display:flex;">
                  <span class="row-item-label comment-row">{{$t('evaluate.easier')}}：</span>
                  <label class="row-item-conent">
                    <el-rate class="rate-choose"
                             :disabled="true"
                             v-model="detailInfo.signVo.serviceFacilitate"></el-rate>
                  </label>
                </div>
              </div>
            </div>
            <div class="comment-bottom">
              <div class="bottom-left">{{$t('evaluate.feedback')}}：</div>
              <div class="bottom-right">
                <label class="row-item-conent"
                       style="max-width:880px; width:880px;">
                  <el-input type="textarea"
                            :maxlength="200"
                            :autosize="{ minRows: 4}"
                            :disabled="true"
                            :placeholder="$t('evaluate.placeholder')"
                            v-model="detailInfo.signVo.feedbackContent"></el-input>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- 客户评价展示结束 -->
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 label-width="160px"
                 class="demo-form-inline"
                 v-if="detailInfo">
          <div style="position:relative;">
            <h2 class="spareInfo">基本信息</h2>
            <!-- <span style="position:absolute;right:30px;top:10px;padding:5px 20px;font-size: 14px;color: #333333;">
          备件需求状态：
          <span v-if="detailInfo.status === '0'" style="color: #1D65A8;">需求已提交</span>
          <span v-if="detailInfo.status === '1'" style="color: #1D65A8;">待确认</span>
          <span v-if="detailInfo.status === '2'" style="color: #1D65A8;">客户已确认</span>
          <span v-if="detailInfo.status === '4'" style="color: #1D65A8;">已取消</span>
          <span v-if="detailInfo.status === '5'" style="color: #1D65A8;">已完成</span>
        </span> -->
          </div>
          <el-row v-if="userInfo"
                  class="row-height">
            <el-col :span="12"
                    class="row-height">
              <el-form-item label="公司名称："
                            prop="userName">
                <label>{{userInfo.companyName}}</label>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
          <el-form-item label="用户名称：" prop="userMobile">
            <label>{{userInfo.name}}</label>
          </el-form-item>
        </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12"
                    class="row-height">
              <el-form-item label="客户负责人："
                            prop="userServiceShopName">
                <label>{{ detailInfo.customerLeaderName }}</label>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    class="row-height">
              <el-form-item label="联系电话："
                            prop="userCompany">
                <label>{{ detailInfo.customerLeaderMobile }}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
                    class="row-date">
              <el-form-item label="备料期望完成日期："
                            prop="userName">
                <label>{{detailInfo.wishEndDate1}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
                    class="row-remark">
              <el-form-item label="备注："
                            prop="userMobile">
                <label>
                  <el-input type="textarea"
                            v-model="detailInfo.remarks"
                            :disabled="true"
                            style="width:600px !important;"
                            :rows="3"></el-input>
                </label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备件需求协议："
                            prop="userCompany">
                <!-- <label v-if="detailInfo.ossFile">{{detailInfo.ossFile.fileName}} <span class="downloadAgreement" @click="download(detailInfo.ossFile.objectName)">下载</span></label> -->
                <ul v-if="detailInfo.ossFile"
                    class="inquiryfj">
                  <li @click="download(item.url,item)"
                      class="pointer"
                      v-for="(item, index) in detailInfo.ossFile"
                      :key="index">
                    <img v-if="item.fileType === 'docx'"
                         src="../../../../assets/img/word.png">
                    <img v-else-if="item.fileType === 'doc'"
                         src="../../../../assets/img/word.png">
                    <img v-else-if="item.fileType === 'zip'"
                         src="../../../../assets/img/zip.png">
                    <img v-else-if="item.fileType === 'xls'"
                         src="../../../../assets/img/excel.png">
                    <img v-else-if="item.fileType === 'xlsx'"
                         src="../../../../assets/img/excel.png">
                    <img v-else-if="item.fileType === 'pdf'"
                         src="../../../../assets/img/ppf.png">
                    <img v-else-if="item.fileType === 'ppt'"
                         src="../../../../assets/img/ppt.png">
                    <img v-else-if="item.fileType === 'pptx'"
                         src="../../../../assets/img/ppt.png">
                    <img v-else-if="item.fileType === 'txt'"
                         src="../../../../assets/img/txt.jpg">
                    <img v-else-if="item.fileType === 'mp4' || item.fileType === 'AVI' || item.fileType === 'rmvb' || item.fileType === 'rm' || item.fileType === 'wmv'"
                         src="../../../../assets/img/mp4.jpg">
                    <img v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                         :src="item.url">
                    <!-- <img v-else src="/static/img/zwtp.png" alt="其他"> -->
                    <i v-else
                       class="el-icon-document"></i>
                    <p>{{item.fileName}}</p>
                  </li>
                </ul>
              </el-form-item>
            </el-col>
          </el-row>
          <h2 class="spareInfo">备件需求信息</h2>
          <el-row>
            <el-table :data="dataList"
                      border
                      v-loading="dataListLoading"
                      @selection-change="selectionChangeHandle"
                      style="width: 100%;">
              <el-table-column type="index"
                               width="50"
                               label="序号"></el-table-column>
              <el-table-column prop="oldGoodsCode"
                               header-align="center"
                               align="center"
                               label="物品编码"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="oldGoodsName"
                               header-align="center"
                               align="center"
                               label="物品名称"
                               width="146"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="oldSpecification"
                               header-align="center"
                               align="center"
                               label="规格"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="oldModel"
                               header-align="center"
                               align="center"
                               label="型号"
                               show-overflow-tooltip></el-table-column>
              <!-- <el-table-column prop="oldConfiguration"
                               header-align="center"
                               align="center"
                               label="配置"
                               show-overflow-tooltip></el-table-column> -->
              <el-table-column prop="oldBrand"
                               header-align="center"
                               align="center"
                               label="品牌"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="price"
                               header-align="center"
                               align="center"
                               label="单价"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="safetyStockQuantityBef"
                               header-align="center"
                               align="center"
                               label="已申请备件量"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="safetyStockQuantity"
                               header-align="center"
                               align="center"
                               label="备件数量"
                               :render-header="renderHeaderNew"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="oldRemark"
                               header-align="center"
                               align="center"
                               label="备注"
                               show-overflow-tooltip></el-table-column>
            </el-table>
          </el-row>
          <el-row style="margin-top:20px">
            <el-col :span="24">
              <el-form-item label="附件：">
                <ul v-if="detailInfo.xyOssFiles"
                    class="inquiryfj inquiryfj-attch">
                  <li @click="download(item.url,item)"
                      class="pointer"
                      v-for="(item, index) in detailInfo.xyOssFiles"
                      :key="index">
                    <img v-if="item.fileType === 'docx'"
                         src="../../../../assets/img/word.png">
                    <img v-else-if="item.fileType === 'doc'"
                         src="../../../../assets/img/word.png">
                    <img v-else-if="item.fileType === 'zip'"
                         src="../../../../assets/img/zip.png">
                    <img v-else-if="item.fileType === 'xls'"
                         src="../../../../assets/img/excel.png">
                    <img v-else-if="item.fileType === 'xlsx'"
                         src="../../../../assets/img/excel.png">
                    <img v-else-if="item.fileType === 'pdf'"
                         src="../../../../assets/img/ppf.png">
                    <img v-else-if="item.fileType === 'ppt'"
                         src="../../../../assets/img/ppt.png">
                    <img v-else-if="item.fileType === 'pptx'"
                         src="../../../../assets/img/ppt.png">
                    <img v-else-if="item.fileType === 'txt'"
                         src="../../../../assets/img/txt.jpg">
                    <img v-else-if="item.fileType === 'mp4' || item.fileType === 'AVI' || item.fileType === 'rmvb' || item.fileType === 'rm' || item.fileType === 'wmv'"
                         src="../../../../assets/img/mp4.jpg">
                    <img v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                         :src="item.url">
                    <!-- <img v-else src="/static/img/zwtp.png" alt="其他"> -->
                    <i v-else
                       class="el-icon-document"></i>
                    <p class="overell">{{item.fileName}}</p>
                  </li>
                </ul>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px">
            <div v-if="detailInfo.status === 1"
                 :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff;margin-right:10px"
                 @click="handleSave()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              确认需求
            </div>
            <div v-if="detailInfo.status === 1"
                 :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff;margin-right:10px"
                 @click="handleCancel()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              取消需求
            </div>
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 @click="routerHandle('spareRequirementsList')">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              返回
            </div>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        id: '',
        dateValue: ''
      },
      detailInfo: null,
      BASE_URL: process.env.BASE_URL,
      userInfo: this.$store.state.user.company,
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      subLoading: false, // 按钮加载中
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: '待受理',
          time: ''
        },
        {
          ind: 2,
          key: '',
          name: '待确认',
          time: ''
        },
        // {
        //   ind: 3,
        //   key: '',
        //   name: '备件中',
        //   time: ''
        // },
        {
          ind: 4,
          key: '',
          name: '已完成',
          time: ''
        },
        {
          ind: 5,
          key: '',
          name: '完成评价',
          time: ''
        }
      ],
      customerEvaluate: {
        serviceQuality: 5,
        serviceFacilitate: 5,
        serviceResponse: 5,
        feedbackContent: ''
      }
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    renderHeaderNew (cerateElement, { column }) {
      return cerateElement('div', [
        cerateElement('span', column.label),
        cerateElement(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: this.$t('message.finalQuantity'),
              placement: 'top'
            }
          },
          [
            cerateElement('i', {
              class: 'el-icon-info',
              style: 'color: #e6a23cmargin-left:2px'
            })
          ]
        )
      ])
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        // if (name === 'spareRequirementsList'){
        //    this.$router.push({name:'spareRequirementsList'})
        // } else {
        this.$router.push({ name: name })
        // }
      } else {
        this.formatFormData()
        this.$router.go(-1)
      }
    },
    // 获取信息
    getInfo () {
      this.dataListLoading = true
      this.$http
        .get(
          `/front/order/lclb/demand/info/${this.$route.query.id}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailInfo = res.data
            this.dataList = res.data.demandDetailList
            if (this.detailInfo.wishEndDate) {
              this.detailInfo.wishEndDate1 = this.detailInfo.wishEndDate.substring(
                0,
                10
              )
            }
            if (this.detailInfo.signVo) {
              this.detailInfo.signVo.serviceResponse =
                this.detailInfo.signVo.serviceResponse / 2
              this.detailInfo.signVo.serviceQuality =
                this.detailInfo.signVo.serviceQuality / 2
              this.detailInfo.signVo.serviceFacilitate =
                this.detailInfo.signVo.serviceFacilitate / 2
            }
            // {code:'0', value:'需求已提交'},
            // {code:'1', value:'待确认'},
            // {code:'2', value:'客户已确认'},
            // {code:'4', value:'已取消'},
            // {code:'5', value:'已完成'}
            if (res.data.applyTime) {
              this.steps[0].time = res.data.applyTime
            }
            if (res.data.acceptDate) {
              this.steps[1].time = res.data.acceptDate
            }
            // if (res.data.confirmDate) {
            //   this.steps[2].time = res.data.confirmDate
            // }
            if (res.data.finishDate) {
              this.steps[2].time = res.data.finishDate
            }
            if (res.data.signDate) {
              this.steps[3].time = res.data.signDate
            }
            if (
              res.data.status === 1 ||
              res.data.status === 4
            ) {
              this.activeIndex = 1
            }
            if (res.data.status === 2) {
              this.activeIndex = 2
            }
            if (res.data.status === 5) {
              this.activeIndex = 3
            }
            if (res.data.status === 6) {
              this.activeIndex = 5
            }
          }
          this.dataListLoading = false
        })
    },
    // 确认需求
    handleSave () {
      if (this.subLoading) {
        return false
      }
      this.subLoading = true
      this.$http
        .post(`/front/order/lclb/demand/confirm`, {
          demandId: this.$route.query.id
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('确认成功')
            this.subLoading = false
            this.$router.push({ name: 'spareRequirementsList' })
          } else {
            this.subLoading = false
          }
        })
    },
    // 取消需求
    handleCancel () {
      this.$confirm(`确定取消该备件需求单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .post(`/front/order/lclb/demand/cancel`, {
            demandId: this.$route.query.id
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                message: '取消成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$router.push({ name: 'spareRequirementsList' })
                }
              })
            }
          })
          .catch(() => {})
      })
    },
    // 提交评价
    handleSubmit () {
      if (this.subLoading) {
        return false
      }
      if (
        this.customerEvaluate.feedbackContent === '' ||
        this.customerEvaluate.feedbackContent === null ||
        this.customerEvaluate.feedbackContent === undefined
      ) {
        this.$message.warning('评价内容不能为空')
        return false
      }
      this.subLoading = true
      this.$http
        .post(`/front/order/lclb/demand/custSign`, {
          billId: this.$route.query.id, // 需求单id(必填)
          feedbackContent: this.customerEvaluate.feedbackContent, // 意见反馈(必填)
          serviceQuality: this.customerEvaluate.serviceQuality * 2, // 服务质量(必填)
          serviceFacilitate: this.customerEvaluate.serviceFacilitate * 2, // 平台便捷性(必填)
          serviceResponse: this.customerEvaluate.serviceResponse * 2 // 响应速度(必填)
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.subLoading = false
            this.getInfo()
          } else {
            this.subLoading = false
          }
        })
    },
    downloadTxt (url) {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response // 获取返回值
          var a = document.createElement('a')
          a.download = ''
          a.href = window.URL.createObjectURL(blob)
          a.click()
        }
      }
      // 发送ajax请求
      xhr.send()
    },
    // 下载
    // 下载文档
    download (item, all) {
      // if (all.fileType === 'txt'){
      //   this.downloadTxt(item)
      //   return
      // }
      var a = document.createElement('a')
      a.href = item
      a.setAttribute('href', a.href)
      a.setAttribute('target', '_blank')
      a.click()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
ul li {
  list-style: none;
}
.two-btns {
  margin-bottom: 20px;
}
.downloadAgreement {
  margin-left: 10px;
  color: #1d65a8;
}
.downloadAgreement:hover {
  cursor: pointer;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inquiryfj {
  padding-left: 160px;
  flex-wrap: wrap;
}
.inquiryfj-attch {
  padding-left: 0px;
}
.inquiryfj li {
  width: 600px;
  height: 50px;
  position: relative;
  cursor: pointer;
  float: left;
}
.inquiryfjx {
  position: absolute;
  right: 0px;
  top: 0;
  width: 20px;
  height: 20px;
}
.inquiryfj li img {
  width: 40px;
  height: 40px;
  float: left;
}
.inquiryfj li p {
  text-align: left;
  font-size: 14px;
  line-height: 40px;
  color: #333333;
  font-weight: bold;
  width: 450px;
  height: 40px;
  text-indent: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
  white-space: nowrap;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.sjz {
  display: flex;
  justify-content: center;
  line-height: 40px;
  padding: 20px 70px;
  background-color: #fff;
}
.sjz-kuaikuai {
  display: flex;
  flex: 1;
}
.sjz-line {
  margin-top: 30px;
  flex: 1;
}
.sjz-item {
  width: 70px;
}
.sjz-icon {
  background: #ffffff;
  border: 1px solid #1d65a8;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 10px;
  margin-left: 15px;
  line-height: 38px;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
}
.sjz-icon .sjc-num {
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
}
.sjz-undone {
  color: #cacaca;
  border: 1px solid #cacaca;
}
.sjz-do {
  background-color: #1d65a8;
  color: #fff;
}
.sjz-icon .el-icon-check {
  font-size: 30px;
  line-height: 38px;
  font-weight: 900;
  color: #1d65a8;
}
.sjz-word {
  /* padding-left: 10px; */
  color: #1d65a8;
  text-align: center;
  width: 100%;
  line-height: 30px;
}
.sjz-time {
  color: #1d65a8;
  text-align: left;
  width: 130px;
  line-height: 20px;
  text-indent: -22px;
}
.sjz-line {
  height: 2px;
  background: #1d65a8;
  width: 20px;
}
// 评价
.box-shadow {
  padding: 40px;
}
.comment-left {
  width: 246px;
  height: 80px;
  float: left;
}
.comment-right {
  float: left;
  height: 80px;
  width: 800px;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  align-items: center;
}
.commnet-top {
  height: 90px;
}
.submit-btn {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.comment-bottom {
  height: 120px;
}
.bottom-left {
  float: left;
  width: 80px;
}
.bottom-right {
  float: left;
  width: 938px;
}
.comment-left img {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 20px;
}
.com-one {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin: 5px 0;
}
.com-new {
  margin-top: 15px;
  margin-bottom: 0px;
}
.row-height {
  height: 24px;
}
.row-margin {
  margin-bottom: 12px;
}
.row-date {
  height: 36px;
}
.row-remark {
  height: 87px;
}
</style>
